<app-upload [userPermission] = "userRole" [businessType]="businessType"></app-upload>
<div class="grid-container padding-y-2">
<div class="grid-row">
  <ag-grid-angular
    style="width: 100%; height: 400px;"
    class="ag-theme-alpine"
    [gridOptions]="updateMessagesOptions"
    [rowData]="rowData"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [columnDefs]="columnDefs"
    [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>
</div>
